
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { getQRCodeUrl } from '@/utils/ImagePathHelper';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

const QRCodeGenerator = () => {
  const [qrUrl, setQrUrl] = useState<string>("");
  const [currentUrl, setCurrentUrl] = useState<string>("");
  
  useEffect(() => {
    // Set the QR code URL and current URL in useEffect to ensure client-side rendering
    const generatedQrUrl = getQRCodeUrl();
    setQrUrl(generatedQrUrl);
    
    // Get the cleaned URL for display (without query parameters or hash)
    const displayUrl = window.location.href.split('#')[0].split('?')[0];
    setCurrentUrl(displayUrl);
    
    console.log("QR Code Component Mounted");
    console.log("Window Location:", window.location.href);
    console.log("QR URL Generated:", generatedQrUrl);
    
    // Test image loading
    const testImage = new Image();
    testImage.onload = () => console.log("QR code image loaded successfully");
    testImage.onerror = (err) => console.error("QR code image failed to load:", err);
    testImage.src = generatedQrUrl;
  }, []);
  
  const handleDownload = () => {
    // Create an anchor element and trigger download
    const a = document.createElement('a');
    a.href = qrUrl;
    a.download = 'beamevaluate-qrcode.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle className="text-center">Scan to access BEAMEvaluate</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center space-y-4">
        <div className="border p-4 rounded-md bg-white">
          {qrUrl && (
            <img 
              src={qrUrl} 
              alt="QR Code for BEAMEvaluate" 
              className="w-[200px] h-[200px]"
              onError={(e) => {
                console.error("QR Code image failed to load:", e);
                // Try to show error message in the image container
                const target = e.currentTarget as HTMLImageElement;
                target.style.display = 'none';
                const parent = target.parentElement;
                if (parent) {
                  const errorMsg = document.createElement('div');
                  errorMsg.textContent = 'QR Code unavailable';
                  errorMsg.className = 'text-red-500 p-4';
                  parent.appendChild(errorMsg);
                }
              }}
            />
          )}
        </div>
        <p className="text-sm text-center text-muted-foreground break-all">
          {currentUrl || "Loading..."}
        </p>
        <Button onClick={handleDownload} className="w-full">
          <Download className="mr-2 h-4 w-4" />
          Download QR Code
        </Button>
      </CardContent>
    </Card>
  );
};

export default QRCodeGenerator;
